export const skeletonTitle = { width: '50%' };
export const skeletonParagraph = { rows: 1, width: 160 };
